import { createBrowserRouter } from "react-router-dom";
import Blog from "../Pages/Blog/Blog";
import Home from "../Pages/Home/Home";
import ProjectDetails from "../Pages/ProjectsDetails/ProjectDetails";

export const router = createBrowserRouter([
    {
        path: '/',
        element: <Home />
    },
    {
        path: '/blog',
        element: <Blog />
    },
    {
        path: '/:id',
        element: <ProjectDetails />,
    },
])